
<div class="PGProfileEditor">
    <div class="row">
        @for (field of ['name','surname','company','vat_number','email','telephone']; track field) {
            <div class="form-group col-12 col-md-6 PGProfileEditor-Field-{{ field.toUpperCase() }}">
                <label for="pg-profile-editor.field-{{field}}">
                    <b>{{ 'pg-profile-editor.field-' + field | locTranslate }}</b>
                    @if(isFieldSometimesRequired(field)) {
                        <span class="PGProfileEditor-Field-Status">
                            <span class="ms-1 small text-{{ (isFieldRequired(field) && !formData[field]) ? 'danger' : 'muted'}}">
                                <i class="fa-regular fa-asterisk fa-sm"></i>
                            </span>
                        </span>
                    }
                </label>

                @if (!formType[field]) {
                    <input id="pg-profile-editor.field-{{field}}" type="text" class="form-control" [(ngModel)]="formData[field]" [readonly]="isFieldReadonly(field)" [required]="isFieldRequired(field)"/>
                }
                @if (formType[field]; as type) {
                    @if (type == 'email') {
                        <app-pg-email id="pg-profile-editor.field-{{field}}" [(ngModel)]="formData[field]" [readonly]="isFieldReadonly(field)" [required]="isFieldRequired(field)"></app-pg-email>
                    }
                    @if (type == 'phone') {
                        <app-pg-phone id="pg-profile-editor.field-{{field}}" [(ngModel)]="formData[field]" [readonly]="isFieldReadonly(field)" [required]="isFieldRequired(field)"></app-pg-phone>
                    }
                }
            </div>
        }
    </div>
    <div class="row border-top mt-3 pt-3">
        <div class="col-12 d-flex justify-content-between align-items-center">
            <div class="text-danger">
                @if(saveError) {
                    <i class="fa-regular fa-circle-exclamation me-2"></i>
                    <span>{{ 'pg-profile-editor.save-error-' + saveError | locTranslate }}</span>
                }
            </div>
            <div>
                <button class="btn btn-primary" [disabled]="!canSave()" (click)="doSave()">
                    <i class="fa-regular fa-save"></i>
                    <span>{{ 'pg-profile-editor.button-save' | locTranslate }}</span>
                </button>
            </div>
        </div>
    </div>
</div>